export default "__VITE_ASSET__32202bd2__"